import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { diceSearchIdentity } from "../../common/utils";

/**
 * Log client đặt cược XX thất bại (Firestore, TTL 14 ngày).
 * Vào trang load ngày hôm nay; lọc uid + giờ/phút; message dài bấm xem chi tiết.
 */

const API = "/luckydice/web/dice-history";
const PAGE_SIZE = 50;
const MSG_PREVIEW = 80;

function todayInputValue() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function formatTime(millis) {
  if (!millis) return "";
  return new Date(millis).toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

function formatIcoin(value) {
  if (value === null || value === undefined) return "";
  return Number(value).toLocaleString("vi-VN");
}

function serverMessage(err) {
  return err && err.response && err.response.data ? err.response.data.message : null;
}

/** date + optional hour/minute → [startMs, endMs) theo giờ VN (local browser = VN khi admin VN). */
function rangeMillis(dateStr, hourStr, minuteStr) {
  if (!dateStr) return { start: null, end: null };
  const base = new Date(dateStr + "T00:00:00");
  if (Number.isNaN(base.getTime())) return { start: null, end: null };

  const hasHour = hourStr !== "" && hourStr != null;
  const hasMin = minuteStr !== "" && minuteStr != null;
  if (!hasHour) {
    return { start: base.getTime(), end: base.getTime() + 24 * 3600 * 1000 };
  }
  const h = Math.min(23, Math.max(0, Number(hourStr)));
  if (!hasMin) {
    const start = new Date(base);
    start.setHours(h, 0, 0, 0);
    const end = new Date(start);
    end.setHours(h + 1, 0, 0, 0);
    return { start: start.getTime(), end: end.getTime() };
  }
  const m = Math.min(59, Math.max(0, Number(minuteStr)));
  const start = new Date(base);
  start.setHours(h, m, 0, 0);
  const end = new Date(start);
  end.setMinutes(m + 1, 0, 0);
  return { start: start.getTime(), end: end.getTime() };
}

function summarizeChips(row) {
  if (row.chips && row.chips.length) {
    return row.chips
      .map((c) => (c.gate || "?") + ":" + formatIcoin(c.value))
      .join(", ");
  }
  if (row.gate) {
    return row.gate + ":" + formatIcoin(row.chipValue);
  }
  return "—";
}

function MessageCell({ text, onOpen }) {
  if (!text) return <span>—</span>;
  if (text.length <= MSG_PREVIEW) {
    return <span style={{ fontSize: "12px" }}>{text}</span>;
  }
  return (
    <button
      type="button"
      className="btn btn-link btn-sm p-0 text-left"
      style={{ fontSize: "12px", maxWidth: "220px", whiteSpace: "normal" }}
      onClick={() => onOpen(text)}
      title="Xem đầy đủ"
    >
      {text.slice(0, MSG_PREVIEW)}… <span className="text-primary">chi tiết</span>
    </button>
  );
}

function DiceBetClientFailsPage() {
  const [keyword, setKeyword] = useState("");
  const [gameId, setGameId] = useState("");
  const [date, setDate] = useState(todayInputValue);
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [rows, setRows] = useState([]);
  const [nextCursor, setNextCursor] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [detailMessage, setDetailMessage] = useState(null);

  function buildBody(cursor) {
    const body = { limit: PAGE_SIZE };
    const gid = gameId.trim();
    if (gid) {
      body.gameId = gid;
    } else {
      const { start, end } = rangeMillis(date, hour, minute);
      body.startDateMillis = start;
      body.endDateMillis = end;
    }
    const value = keyword.trim();
    if (value) {
      Object.assign(body, diceSearchIdentity(value));
    }
    if (cursor) body.cursor = cursor;
    return body;
  }

  async function search(showEmptyToast) {
    if (!gameId.trim() && !date) {
      toast.warn("Chọn ngày hoặc nhập gameId");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(global.config.apiDomain + API + "/client-fails", buildBody(null));
      setRows(res.data.rows || []);
      setNextCursor(res.data.nextCursor || null);
      setHasMore(!!res.data.hasMore);
      if (showEmptyToast && (!res.data.rows || res.data.rows.length === 0)) {
        toast.info("Không có log fail trong khoảng này");
      }
    } catch (err) {
      setRows([]);
      setNextCursor(null);
      setHasMore(false);
      toast.error(serverMessage(err) || "Lỗi khi tải log fail");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    search(false);
  }, []);

  async function loadMore() {
    if (!nextCursor) return;
    setLoadingMore(true);
    try {
      const res = await axios.post(
        global.config.apiDomain + API + "/client-fails",
        buildBody(nextCursor)
      );
      setRows((prev) => prev.concat(res.data.rows || []));
      setNextCursor(res.data.nextCursor || null);
      setHasMore(!!res.data.hasMore);
    } catch (err) {
      toast.error(serverMessage(err) || "Lỗi khi tải thêm");
    } finally {
      setLoadingMore(false);
    }
  }

  const inputStyle = { width: "auto", minWidth: "70px", marginRight: "8px" };

  return (
    <div className="container-fluid" style={{ marginTop: "90px", marginBottom: "80px", paddingLeft: "24px", paddingRight: "24px" }}>
      <h1 className="text-center" style={{ fontSize: "1.6rem" }}>Log đặt cược XX thất bại</h1>

      <div
        className="d-flex flex-wrap align-items-center justify-content-center"
        style={{ marginTop: "20px", gap: "6px 4px" }}
      >
        <input
          className="form-control form-control-sm"
          style={{ ...inputStyle, minWidth: "200px" }}
          value={gameId}
          onChange={(e) => setGameId(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && search(true)}
          placeholder="gameId"
          title="Ưu tiên: mọi user trong ván"
        />
        <input
          className="form-control form-control-sm"
          style={{ ...inputStyle, minWidth: "120px" }}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && search(true)}
          placeholder="uid / userId"
        />
        <input
          type="date"
          className="form-control form-control-sm"
          style={{ ...inputStyle, minWidth: "140px" }}
          value={date}
          onChange={(e) => setDate(e.target.value)}
          disabled={!!gameId.trim()}
        />
        <input
          type="number"
          min={0}
          max={23}
          className="form-control form-control-sm"
          style={{ ...inputStyle, width: "72px", minWidth: "72px" }}
          value={hour}
          onChange={(e) => setHour(e.target.value)}
          disabled={!!gameId.trim()}
          placeholder="giờ"
          title="0–23 (trống = cả ngày)"
        />
        <input
          type="number"
          min={0}
          max={59}
          className="form-control form-control-sm"
          style={{ ...inputStyle, width: "72px", minWidth: "72px" }}
          value={minute}
          onChange={(e) => setMinute(e.target.value)}
          disabled={!!gameId.trim() || hour === ""}
          placeholder="phút"
          title="0–59 (cần chọn giờ)"
        />
        <button className="btn btn-primary btn-sm" onClick={() => search(true)} disabled={loading}>
          {loading ? "…" : "Tìm"}
        </button>
      </div>
      <p className="text-center text-muted mb-0" style={{ marginTop: "6px", fontSize: "12px" }}>
        Mặc định ngày hôm nay. Có gameId → bỏ qua ngày/giờ. Giờ/phút thu hẹp cửa sổ.
      </p>

      <div className="table-responsive" style={{ marginTop: "20px" }}>
        <table className="table table-bordered table-hover table-sm">
          <thead className="table-primary">
            <tr>
              <th>No</th>
              <th>Thời gian</th>
              <th>uid</th>
              <th>userId</th>
              <th>requestId</th>
              <th>gameId</th>
              <th>path</th>
              <th>Cược</th>
              <th>Tổng</th>
              <th>errorKind</th>
              <th>category</th>
              <th>phase</th>
              <th>ms</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <tr key={row.requestId + "-" + index}>
                  <td>{index + 1}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{formatTime(row.clientTs)}</td>
                  <td>{row.uid != null ? row.uid : "—"}</td>
                  <td style={{ maxWidth: "120px", wordBreak: "break-all", fontSize: "11px" }}>
                    {row.userId}
                  </td>
                  <td style={{ maxWidth: "120px", wordBreak: "break-all", fontSize: "11px" }}>
                    {row.requestId}
                  </td>
                  <td style={{ fontSize: "11px" }}>{row.gameId || "—"}</td>
                  <td>{row.path || "—"}</td>
                  <td style={{ fontSize: "11px" }}>{summarizeChips(row)}</td>
                  <td>{formatIcoin(row.totalChip)}</td>
                  <td>
                    <span className="badge badge-warning">{row.errorKind || "—"}</span>
                  </td>
                  <td style={{ fontSize: "11px" }}>{row.category || row.blockReason || "—"}</td>
                  <td style={{ fontSize: "11px" }}>{row.phase || "—"}</td>
                  <td>{row.durationMs != null ? row.durationMs : "—"}</td>
                  <td>
                    <MessageCell text={row.serverMessage} onOpen={setDetailMessage} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={14} className="text-center">
                  {loading ? "Đang tải..." : "Không có dữ liệu"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {hasMore && (
        <div className="text-center" style={{ marginTop: "12px" }}>
          <button className="btn btn-outline-primary btn-sm" onClick={loadMore} disabled={loadingMore}>
            {loadingMore ? "Đang tải..." : "Tải thêm"}
          </button>
        </div>
      )}

      {detailMessage && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show" tabIndex="-1" style={{ display: "block" }} role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Chi tiết message</h5>
                  <button type="button" className="close" onClick={() => setDetailMessage(null)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: "13px", margin: 0 }}>
                    {detailMessage}
                  </pre>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => setDetailMessage(null)}>
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default DiceBetClientFailsPage;
